const listeners = new Map();

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const callback = listeners.get(entry.target);
      if (callback) {
        callback(entry);
        observer.unobserve(entry.target);
        listeners.delete(entry.target);
      }
    }
  });
}, {
  rootMargin: '200px',
  threshold: 0.1
});

/**
 * Подключает элемент к единому обсерверу
 * @param {Element} el - DOM элемент
 * @param {Function} callback - функция, вызываемая при появлении элемента в зоне видимости
 */

export function observeOnce(el, callback) {
  if (!el || typeof callback !== 'function') return;
  listeners.set(el, callback);
  observer.observe(el);
}

/**
 * Прекратить наблюдение за элементом (если нужно досрочно)
 * @param {Element} el 
 */
export function unobserve(el) {
  if (!el) return;
  observer.unobserve(el);
  listeners.delete(el);
}